import React from 'react';
import PropTypes from 'prop-types';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import UsersListFilters from './UsersListFilters';
import listQueryFilter from 'components/hoc/listQueryFilter';
import theme from 'theme/theme';
import { deleteUser } from 'store/actions/users/deleteUsers';
import { fetchUsers } from 'store/actions/users/fetchUsers';

const UsersList = (props) => {
    const {
        actionType,
        deleteActionParams,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <UsersListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchUsers }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: theme.palette.gray,
                        key: 'is_enabled',
                    } }
                >
                    <TextField
                        column={ {
                            sortable: true,
                            width: '30%',
                        } }
                        label='resources.users.fields.lastname'
                        maxCharacters={ 100 }
                        source='last_name'
                    />

                    <TextField
                        column={ {
                            width: '30%',
                        } }
                        label='resources.users.fields.firstname'
                        source='first_name'
                    />

                    <TextField
                        column={ {
                            width: '30%',
                        } }
                        label='resources.users.fields.email'
                        source='email'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteUser } params={ deleteActionParams } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

UsersList.propTypes = {
    actionType: PropTypes.string.isRequired,
    deleteActionParams: PropTypes.object,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(UsersList);



// WEBPACK FOOTER //
// ./src/pages/users/list/UsersList.js